import { render } from "./GenreDetail.vue?vue&type=template&id=23e5bb0b&scoped=true"
import script from "./GenreDetail.vue?vue&type=script&lang=js"
export * from "./GenreDetail.vue?vue&type=script&lang=js"

import "./genres.scss?vue&type=style&index=0&id=23e5bb0b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e5bb0b"]])

export default __exports__